// extracted by css-extract-rspack-plugin
export default {"sortGroupMobileOnly":"SortMenu-module__sortGroupMobileOnly__cGQmM","sortLabel":"SortMenu-module__sortLabel__PSPIC"};